import { Link } from "react-router-dom";
import { MdLock } from "react-icons/md";
import styles from "./AppSidebar.module.css";

/**
 * Single nav tab primitive for AppSidebar.
 * Link and action (e.g. logout) share the exact same layout, size and typography.
 */
const SidebarNavItem = ({
  label,
  icon,
  expanded = true,
  active = false,
  locked = false,
  to,
  onClick,
  title,
}) => {
  const className = `${styles.navItem} ${active ? styles.navItemActive : ""}`;
  const tooltipTitle = title ?? label;
  const content = (
    <>
      <span className={styles.navIconWrap} aria-hidden>
        {icon}
        {locked ? <MdLock className={styles.lockBadge} /> : null}
      </span>
      {expanded ? <span className={styles.navLabel}>{label}</span> : null}
      {!expanded ? <span className={styles.tooltip}>{label}</span> : null}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={className}
        title={expanded ? undefined : tooltipTitle}
        aria-current={active ? "page" : undefined}
        onClick={onClick}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      title={expanded ? undefined : tooltipTitle}
      onClick={onClick}
      aria-current={active ? "true" : undefined}
    >
      {content}
    </button>
  );
};

export default SidebarNavItem;
